import React from "react";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCodigoPostalCpt } from "../../api/getCodigoPostalCpt";
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";
import "./styleDomPersonal.css";
import Select from 'react-select';

function DataDomPersonal() {

  const [codigoPostal, setCodigoPostal] = useState("");
  const [colonia, setColonia] = useState("");
  const [calle, setCalle] = useState("");
  const [numExterior, setnumExterior] = useState("");
  const [numInterior, setnumInterior] = useState("");
  const [tipoColonia, setTipoColonia] = useState([]);
  const [blContinue, setBlContinue] = useState(true);
  const isRunned = useRef(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ToDo
  const handleSubmit = (event) => {
    event.preventDefault();
    // Enviar los datos del formulario a través de una petición HTTP
  };

  const handkeOnKeyDown = async (event) => {
    if (
      event.code === "Enter" ||
      event.code === "NumpadEnter" ||
      event.keyCode === 13
    ) {

      const modelCodigoPostal = {
        cp: codigoPostal
      }

      const response = await getCodigoPostalCpt(modelCodigoPostal);
      if (response.status === 200) {
        setTipoColonia(response.listRest);
      } else {
        setTipoColonia([]);
      }
    }
  };

  const handleChangeLic = async (selectedOption) => {
    const setSelectedOption = selectedOption.tipoColonia;
    localStorage.setItem('tipoColonia', setSelectedOption);
  };

  const getContinue = async () => {
    navigate("#", {
      state: { user: "userTest" },
    });
  };


  const style = {
    control: base => ({
      ...base,
      height: "52px !important",
      borderRadius: "0.375rem !important",
      boxShadow: "none !important",
      borderColor: "#c4cbd1 !important",
      "&:hover": {
        borderColor: "#c4cbd1 !important"
      }
    })
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/HomeDomPersonal"
          title="Domicilio personal"
          name="DataDomPersonal"
        />
        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <div className="txtOp_P2">Dirección de referencia</div>
              <div className="subTitle">Dirección laboral o donde normalmente despeña su actividad diaria.</div>
              <hr className="separadorLine" />
              <div>
                <form onSubmit={handleSubmit}>
                  <div>
                    <div className="txtSubtitle">Código Postal:</div>
                    <input
                      type="text"
                      value={codigoPostal}
                      onKeyDown={handkeOnKeyDown}
                      onChange={(event) => setCodigoPostal(event.target.value)}
                    />
                  </div>

                  <div>
                    <div className="txtSubtitle">Colonia:</div>
                    <div>
                      <Select
                        styles={style}
                        className="select-wrapper"
                        classNamePrefix="select"
                        placeholder="Selecciona la colonia"
                        options={tipoColonia}
                        value={tipoColonia}
                        onChange={handleChangeLic}
                        formatOptionLabel={tipoColonia => (
                          <div className="containerEmisor">
                            <>
                              <div className="licenciaValue">{tipoColonia.asentamiento}</div>
                            </>
                          </div>
                        )}
                      />
                    </div>

                    <div />
                  </div>
                  <div>
                    <div className="txtSubtitle">Calle:</div>
                    <input
                      type="text"
                      value={calle}
                      onChange={(event) => setCalle(event.target.value)}
                    />
                  </div>
                  <div className="contenedorNum ">
                    <div className="numExt">
                      <div className="txtSubtitle">Exterior:</div>
                      <input
                        type="text"
                        value={numExterior}
                        onChange={(event) => setnumExterior(event.target.value)}
                      />
                    </div>
                    <div className="numInt">
                      <div className="inputWrap">
                        <div className="txtSubtitle">Interior:</div>
                        <input
                          type="text"
                          value={numInterior}
                          onChange={(event) => setnumInterior(event.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <hr className="line" />
              <div className='btnContinue'>
                {!blContinue ? (
                  <>
                    <button className='btnVer_P3'>
                      <span className='txtVer_P3'>Mapear</span>
                    </button>
                  </>
                ) : (
                  <>
                    <div className='containerCont_P2'>
                      <div className="spaceButton14">
                        <button className='button_P2 animate__animated animate__fadeIn' type="submit" onClick={getContinue}>
                          <span className='txtButton_P2'>Mapear</span>
                        </button>
                      </div>
                      <div className="spaceButton14">
                        <button className='buttonRein_P2'>
                          <span className='txtButtonRein_P14'>Reintentar</span>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
}

export default DataDomPersonal;
